import React, { useEffect } from "react";
import { useRouteMatch } from "react-router-dom";
import { useQuery } from "@apollo/react-hooks";
import { TRANSACTION } from "../queries";
import Base from "../../core/components/Base";
import WhiteBox from "../../core/components/WhiteBox";
import TransactionForm from "../components/TransactionForm";
import BaseNotFoundPage from "../../core/pages/BaseNotFoundPage";

const EditTransactionPage = () => {
  /**
   * Page for editing a transaction
   */

  const transactionId = useRouteMatch("/money/transactions/:id/edit/").params.id;
  const {loading, data, error} = useQuery(TRANSACTION, {variables: {id: transactionId}});
  const transaction = loading || error ? {} : data.user.transaction;

  useEffect(() => {
    if (!loading && !error) {
      document.title = `${transaction.value} ${transaction.account.currency} - lytiko`;
    }
  });

  if (error) {
    try {
      const message = JSON.parse(error.graphQLErrors[0].message);
      if (message.transaction === "Does not exist") {
        return <BaseNotFoundPage />
      }
    } catch {  }
  }

  if (loading) {
    return (
      <Base className="edit-transaction-page">
        <WhiteBox className="transaction-form" loading={true} />
      </Base>
    )
    
  }

  return (
    <Base className="edit-transaction-page">
      <TransactionForm transaction={transaction} account={transaction.account} />
    </Base>
  )
}

export default EditTransactionPage;